export const environment = {
  production: true,
  envFileUrl: 'app-config.json'
}
